"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitShopifyId = void 0;
var splitShopifyId = function (shopifyId) {
    // Example of Shopify Product Variant ID - "gid://shopify/ProductVariant/43714992668970"
    var _a = shopifyId.split('ProductVariant/'), type = _a[0], id = _a[1];
    return { type: type, id: id };
};
exports.splitShopifyId = splitShopifyId;
